import React from "react";
import { Box, Skeleton } from "@mui/material";
import PageContainer from "../PageContainer";

/**
 * Shown while a lazy page's code downloads, for pages without a skeleton of
 * their own (Ad Center, the worksheet generator). Grey blocks, never a spinner.
 */
const RouteLazyFallback: React.FC = () => (
  <PageContainer>
    <Box role="status" aria-label="Loading page" sx={{ mt: 1 }}>
      <Skeleton variant="text" width={240} sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }} />
      <Skeleton variant="text" sx={{ fontSize: "1rem", mb: 3, maxWidth: 520 }} />
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
          gap: 2,
        }}
      >
        {[0, 1, 2].map((card) => (
          <Skeleton key={card} variant="rounded" height={200} />
        ))}
      </Box>
    </Box>
  </PageContainer>
);

export default RouteLazyFallback;
